import React from 'react';
import { Link } from 'react-router-dom';

const Trabaja = () => {
  return (
    <section id="trabaja" className="mx-auto min-[1708px]:bg-trabaja bg-white bg-contain bg-right bg-no-repeat py-32">
          <div className="mx-auto min-[1708px]:ml-20 flex flex-col min-[1708px]:items-center content-between max-w-4xl px-6 lg:px-8 text-center">
            <h2 className="text-3xl min-[1708px]:text-left font-bold tracking-tight sm:text-5xl text-gray-900 mb-10">
              Trabaja con Nosotros
            </h2>
            <p className="text-base min-[1708px]:text-left flex-wrap max-w-screen-lg lg:text-2xl text-gray-600 mb-10">
            Estamos constantemente buscando los mejores talentos en el área para ejecutar labores submarinas con presición. Si quieres ser parte de nuestro equipo puedes contactarnos a través de los siguientes formularios.
            </p>
            <div className="mx-auto flex flex-col sm:flex-row justify-around flex-wrap sm:flex-nowrap gap-8 items-center mt-10">
                <div className="max-w-md flex flex-row justify-center flex-wrap lg:flex-nowrap gap-2">
                  <Link to="https://forms.gle/k6nJ214Z8hmbag4w6" target="_blank">
                    <button className="btn mt-3">Buceo Profesional</button>
                  </Link>
                  <Link to="https://forms.gle/zpnuEGRmotZ9axSH8" target="_blank">
                    <button className='btn mt-3'>Piloto ROV</button>
                  </Link>
                </div>
            </div>
          </div>
        </section>
  )
}

export default Trabaja